import React from 'react';
import {
  APP_NAME,
  CONTACT_EMAIL,
  PRIVACY_POLICY_DATE,
  APP_YEAR
} from '../../constants'
import Logo from '../Logo';
import { HOME_PAGE } from "../../constants";
import { Link } from 'react-router-dom';
import './index.css';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const PrivacyPolicy = () => {
  return (
    <Container className="pt-card pt-dark no-border-radius">
      <div className="PrivacyPolicy">
        <div className="horizontal-divider"/>
        <div className="flex-center-column full-width">
          <Link to={HOME_PAGE} className="transparent-hoover-link">
            <Logo dark/>
          </Link>
        </div>
        <div className="horizontal-divider"/>
        <div className="PrivacyPolicy-title">
          <h2>PRIVACY POLICY</h2>
          <p><i>Effective Date: {PRIVACY_POLICY_DATE}, {APP_YEAR}</i></p>
        </div>
        <div>
          <p>This Privacy Policy informs you of our policies and procedures
            regarding the collection, use and disclosure of personal
            information
            we receive from users of our {APP_NAME} web application. This
            Privacy Policy applies only to information that you provide to us.
            This Privacy Policy may be updated from time to time. We will
            notify
            you of any material changes by posting the new Privacy Policy on
            the
            primary access points to {APP_NAME}. You are advised to consult
            this policy regularly for any changes.</p>
          <br/>
          <h4>Information Collection and Use</h4>
          <ul>
            <li>In the course of using {APP_NAME}, you may provide us with
              personally identifiable information. This refers to information
              about you that can be used to contact or identify you ("Personal
              Information"). Personal Information includes, but is not limited
              to, your name, email address, and phone number.
            </li>
            <li>We use your Personal Information (in some cases, in conjunction
              with your non-identifying information) mainly to deliver
              alerting.
            </li>
            <li>We also use your Personal Information (in some cases, in
              conjunction with your non-identifying information) to contact you
              with newsletters, marketing or promotional materials and other
              information that may be of interest to you. If you decide at any
              time that you no longer wish to receive such communications from
              us, please follow the unsubscribe instructions provided in any of
              the communications.
            </li>
          </ul>
          <br/>
          <h4>Cookies</h4>
          <p>
            We may use cookies to help improve the use of {APP_NAME}. For
            example, we may use a cookie to recognize your computer and input
            information that you have previously given to us to save you having
            to give us your information again. Although most web browsers
            automatically accept cookies, you can usually change your browser
            settings to prevent this or to notify you when you are sent a
            cookie.
            If you decide not accept cookies from us, you may enjoy a reduced
            user experience when you use {APP_NAME}.
          </p>
          <br/>
          <h4>Contacting Us</h4>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at {CONTACT_EMAIL}
          </p>
        </div>
      </div>
    </Container>
  )
};

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy/index.js